import React from 'react'
import { Spinner } from '@pinflag/pinflag-ui-kit'

const RedirectLoader = () => (
  <div className='fixed inset-0 z-[9999] bg-white flex items-center justify-center'>
    <Spinner/>
  </div>
)

export default RedirectLoader
